/* eslint-disable no-unused-vars */

$('#blog-categories');

$('.js-blog-category').on('change', function () {
  if (this.value !== 'none') {
    $(this).closest('form').submit();
  }
});

$('.js-blog-tags').click(function (e) {
  e.preventDefault();
  $('.js-blog-tags-block').toggleClass('d-none');
});

window.BlogCategory = {
  onUpdateSuccess: function (data, status, xhr) {
    $('#update-blog-items').remove();
  }
};
// // import 'bootstrap-select';
// import React, { Component } from 'react';
// import ReactDom from 'react-dom';
// import PropTypes from 'prop-types';
// import Select from 'react-select';

// // $.fn.selectpicker.Constructor.BootstrapVersion = '4';

// class TagSelect extends Component {

//     constructor(props) {
//         super(props);

//         this.state = {
//             options: this.props.options,
//             selected: this.props.selected || [],
//         };
//         this.handleChange = this.handleChange.bind(this);
//     }

//     handleChange() {

//     }

//     render() {
//         return (
//             <React.Fragment>
//                 <Select
//                     options={this.props.options}
//                     isMulti={this.props.multiple}
//                     selectOption={this.state.selected}
//                     onChange={(selected) => {
//                         this.setState({
//                             selected,
//                         });
//                     }}

//                 />
//                 <br />
//                 <input
//                     type="text"
//                     readOnly={true}
//                     value={this.state.selected.map(item => item.value).join(',')}
//                 />
//             </React.Fragment>
//         );
//     }
// }

// TagSelect.propTypes = {
//     options: PropTypes.array,
//     multiple: PropTypes.bool,
//     selected: PropTypes.array,
// };

// // export default TagSelect;

// // $('#blog-categories').selectpicker();
// $('#blog-tags').each(function () {

//     const options = [];
//     const selected = [{ value: '3240', label: 'SEN' }];

//     $(this).find('option').each(function () {
//         options.push({
//             label: $(this).text(),
//             value: $(this).attr('value'),
//         });
//         if ($(this).prop('selected')) {
//             // selected.push($(this).attr('value'));
//             selected.push({
//                 label: $(this).text(),
//                 value: $(this).attr('value'),
//             });
//         }
//     });

//     console.log('options', options);

//     ReactDom.render(
//         <TagSelect options={options} selected={selected} multiple={true} />,
//         $(this).parent()[0]);

// });
